/*!
 * This file was created to avoid usage of "global `cast.framework` values" (constants/enums/classes/etc.) that should be
 * defined by JavaScript file `cast_receiver_framework.js` imported by the Web Cast Receiver app. We should not relay on it,
 * and instead, we should define our own necessary primitive values and constants we need.
 *
 * We should still use "type imports" (`import type {}`) from the `@types/chromecast-caf-receiver` package!
 *
 * Cypress test should cover "copies of the library values" to be sure they are up to date with the library!
 */

import type {EventType} from 'chromecast-caf-receiver/cast.framework.events';

/**
 * https://developers.google.com/cast/docs/reference/web_receiver/cast.framework.events#.EventType
 */
export const CastFrameworkEvent = {
  ALL: '*' as EventType.ALL,
  BUFFERING: 'BUFFERING' as EventType.BUFFERING,
  ERROR: 'ERROR' as EventType.ERROR,
  LOADED_METADATA: 'LOADED_METADATA' as EventType.LOADED_METADATA,
  PAUSE: 'PAUSE' as EventType.PAUSE,
  PLAY: 'PLAY' as EventType.PLAY,
  PLAYING: 'PLAYING' as EventType.PLAYING,
  PLAYER_LOAD_COMPLETE: 'PLAYER_LOAD_COMPLETE' as EventType.PLAYER_LOAD_COMPLETE,
  REQUEST_LOAD: 'REQUEST_LOAD' as EventType.REQUEST_LOAD,
  SEEKED: 'SEEKED' as EventType.SEEKED,
  SEEKING: 'SEEKING' as EventType.SEEKING,
  STALLED: 'STALLED' as EventType.STALLED,
  TIME_UPDATE: 'TIME_UPDATE' as EventType.TIME_UPDATE,
} as const;
